import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getActivitiesInProject, getOverallTabData, getProjectStatistics } from '../../../apis/impact-report/report';
import IndexPageComponent from './pdf/IndexPageComponent';
import IntroductionPageComponent from './pdf/IntroductionPageComponent';
import ActivityPagesComponent from './pdf/ActivityPagesComponent';
import OverallTabPageComponent from './pdf/OverallTabPageComponent';
import FourthPageComponent from './pdf/FourthPageComponent';
import ActivityTypesPageComponent from './pdf/ActivityTypesPageComponent';
import FifthPageComponent from './pdf/FifthPageComponent';
import SDGsPageComponent from './pdf/SDGsPageComponent';
import SixthPageComponent from './pdf/SixthPageComponent';
import FundsPageComponent from './pdf/FundsPageComponent';
import PdfFooterComponent from './pdf/PdfFooterComponent';


const PdfOnlyContent = ({ projectData = null }) => {
  const { projectId } = useParams();
  const [activities, setActivities] = useState([]);
  const [overallData, setOverallData] = useState(null);
  const [activitiesData, setActivitiesData] = useState(null);
  const [activityTypesData, setActivityTypesData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        // Fetch activities - get all activities for pagination
        const activitiesResponse = await getActivitiesInProject(projectId);
        setActivities(activitiesResponse || []); // Get all activities

        // Fetch overall tab data for metrics and charts
        const overallResponse = await getOverallTabData(projectId);
        setOverallData(overallResponse);

        // Fetch activities chart data
        const activitiesChartResponse = await getProjectStatistics(projectId, "BOUNTY_WISE_SUBMISSION_COUNT", "", "");
        setActivitiesData(activitiesChartResponse);

        // Fetch activity types chart data
        const activityTypesChartResponse = await getProjectStatistics(projectId, "BOUNTY_TYPE_WISE_SUBMISSION_COUNT", "", "");
        setActivityTypesData(activityTypesChartResponse);

      } catch (error) {
        console.error('Error fetching PDF data:', error);
        setActivities([]);
        setOverallData(null);
        setActivitiesData(null);
        setActivityTypesData(null);
      } finally {
        setLoading(false);
      }
    };

    if (projectId) {
      fetchAllData();
    }
  }, [projectId]);

  if (loading) {
    return (
      <div id="pdf-content" className="pdf-container" style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}>
        <div className="flex items-center justify-center h-64">
          <div className="text-lg">Loading PDF content...</div>
        </div>
      </div>
    );
  }

  // Calculate dynamic page numbers
  const activitiesPerPage = 2;
  const activityPagesCount = Math.ceil(activities.length / activitiesPerPage);
  const dataVisualizationStartPage = 3 + activityPagesCount;

  return (
    <div id="pdf-content" className="pdf-container" style={{ position: 'relative', width: '210mm', minHeight: '297mm', backgroundColor: 'white', margin: '20px auto', border: '1px solid #ccc' }}>
      {/* Page 1: Index/Table of Contents */}
      <IndexPageComponent 
        projectTitle={projectData?.title || "Water Network Project"} 
        organizationName="Solarpunk Guild" 
        activities={activities} 
        activityPagesCount={activityPagesCount} 
      />
      
      {/* Page 2: Introduction with About and Overview only */}
      <IntroductionPageComponent projectData={projectData} overallData={overallData} />
      
      {/* Pages 3+: All Activities (2 per page) */}
      <ActivityPagesComponent activities={activities} projectData={projectData} />
      
      {/* Overview Page (after activities) */}
      
      <OverallTabPageComponent overallData={overallData} projectData={projectData} />
      
      {/* Data Visualization Pages (start after overview) */}
      {/* Activities Chart Pages (paginated) */}
      <FourthPageComponent activitiesData={activitiesData} projectData={projectData} />
      
      {/* Activity Types Chart Page */}
      <ActivityTypesPageComponent activityTypesData={activityTypesData} projectData={projectData} />
      
      {/* Impact Certificates Pages (paginated) */}
      <FifthPageComponent projectId={projectId} projectData={projectData} />
      
      {/* SDGs Pages (paginated) */}
      <SDGsPageComponent projectId={projectId} projectData={projectData} />
      
      {/* Contributions Pages (paginated) */}
      <SixthPageComponent projectId={projectId} projectData={projectData} />
      
      {/* Funds Pages (paginated) */}
      <FundsPageComponent projectId={projectId} projectData={projectData} />
      
      {/* Footer for all pages */}
      {/* <PdfFooterComponent /> */}
    </div>
  );
};

export default PdfOnlyContent;
